import Masonry from 'masonry-layout';

var masonry = null;

(function (Drupal) {
    Drupal.behaviors.fieldContactsMasonry = {
        attach: function (context, settings) {
            once("contacts-masonry", ".field--name-field-contacts", context).forEach(function (element) 
            {
                // Card size
                const sizer = 'masonry-sizer';
                const sizerElement = document.createElement('div');
                sizerElement.classList.add(sizer);

                // GAP between cards size
                const gutter = 'masonry-gutter';
                const gutterElement = document.createElement('div');
                gutterElement.classList.add(gutter);

                // Append elements
                element.appendChild(sizerElement);
                element.appendChild(gutterElement);

                // Initialize Masonry
                masonry = new Masonry(element, {
                    itemSelector: '.field--name-field-contacts article.node',
                    columnWidth: '.masonry-sizer',
                    gutter: '.masonry-gutter',
                    percentPosition: true
                });  
            });
        },
    };
})(Drupal);
